<div class="min-h-screen flex items-center justify-center overflow-hidden p-4">
    <div class="border-solid border-2 border-opacity-25 rounded-2xl p-5 w-full md:w-4/5 lg:w-3/5 xl:w-1/2 shadow-[0_2px_22px_-4px_rgba(93,96,127,0.2)]">
        <div>
            <div class="m-5 flex justify-center">
                <h1 class="text-lg font-bold text-azul">{{'iniciar-sesion' | translate}}</h1>
            </div>
            <form [formGroup]="formLogin" (ngSubmit)="iniciarSesion()">
                <!-- Email  -->
                <div class="m-5 mb-7 flex justify-center">
                    <mat-form-field class="w-full md:w-2/3" appearance="outline" hideRequiredMarker>
                        <mat-label class="bg-white p-1">{{'Correo-Electronico' | translate}}</mat-label>
                        <input type="email" matInput formControlName="email" placeholder="{{'Correo-Electronico' | translate}}">
                        <mat-error *ngIf="controlarErrores('email', 'required')">{{'introduce-una-direccion' | translate}} <strong>{{'correo-electronico' | translate}}</strong></mat-error>
                        <mat-error *ngIf="controlarErrores('email','email')">{{'direccion-correo' | translate}} <strong>{{'no-valida' | translate}}</strong></mat-error>
                    </mat-form-field>
                </div>
                <!-- Password -->
                <div class="m-5 flex justify-center">
                    <mat-form-field class="w-full md:w-2/3" appearance="outline" hideRequiredMarker>
                        <mat-label class="bg-white p-1">{{'introduce-tu-password' | translate}}</mat-label>
                        <input matInput [type]="mostrarPassword ? 'text' : 'password'" formControlName="password" placeholder="{{'introduce-tu-password' | translate}}">
                        <mat-icon matSuffix (click)='cambiarVisibilidadPassword()'>{{mostrarPassword ? 'visibility_off':'visibility'}}</mat-icon>
                        <mat-error *ngIf="controlarErrores('password', 'required')">{{'introduce-tu' | translate}} <strong>{{'password' | translate}}</strong></mat-error>
                    </mat-form-field>
                </div>
                <div class="flex justify-center">
                    <button type="submit" [disabled]="!formLogin.valid" class="p-2 bg-azul text-white w-full md:w-1/2 rounded-full" (click)="iniciarSesion()">{{'iniciar-sesion' | translate}}</button>
                </div>
            </form>
            <!-- Registro de nuevos usuarios -->
            <div class="m-5 flex justify-center">
                <div class="space-x-1">
                    <span>{{'no-tienes-cuenta' | translate}}</span>
                    <a routerLink="/registro" class="text-azul"><strong>{{'reguistrate-aqui' | translate}}</strong></a>
                </div>
            </div>
            <!-- Volver a inicio -->
            <div class="m-5 flex justify-end">
                <div class="space-x-1">
                    <a href="/" class="text-azul flex items-center"><mat-icon>keyboard_arrow_left</mat-icon><span><strong>{{'volver-inicio' | translate}}</strong></span></a>
                </div>
            </div>
            <!-- Mostrar alertas error inicio de sesion -->
            <div *ngIf="mostrarError">
                <nz-alert nzType="error" nzCloseable (nzOnClose)="cerrarAlerta()" nzMessage="{{'err-is' | translate}}" nzDescription="{{'text-err-is' | translate}}" nzShowIcon></nz-alert>
            </div>
        </div>
</div>
</div>

